import { Observable } from 'rxjs'
import { OpenItem, Address, PageableSearch, DisplayOrder } from "../../models"
import { Query } from "../../services"
import { OpenItemsActions } from './open-items.actions';
export interface OpenItemsState {
	openItemSearch: PageableSearch<OpenItem>
	openItem: OpenItem
	showDisplayOrderSpinner: boolean
};

const initialState: OpenItemsState  = {
	openItemSearch: {
		content: [],
		first: false,
		last: false,
		number: 0,
		numberOfElements: 0,
		size: 0,
		totalElements: 0,
		totalPages: 0
	},
	openItem: null,
	showDisplayOrderSpinner: false,
}


export const openItemsReducer = (state = initialState, action): OpenItemsState => {
	switch (action.type) {
		case OpenItemsActions.OPEN_ITEMS_SEARCH_SUCCESS: {
			return Object.assign({}, state,
				{
					openItemSearch: action.payload,
					showDisplayOrderSpinner: false
				})
		}

		case OpenItemsActions.OPEN_ITEMS_SEARCH: {
			return Object.assign({}, state,
				{
					showDisplayOrderSpinner: true
				})
		}

		case OpenItemsActions.OPEN_ITEM_LOADED: {
			return Object.assign({}, state,
				{
					openItem: action.payload
				})
		}

		default: return state;
	}

}


// WEBPACK FOOTER //
// ./src/app/components/open-items/open-items.reducer.ts